let hasStartedSignup = false;
let engagementCount = 0;

export const markSignupFunnelStarted = (): void => {
    hasStartedSignup = true;
};

export const hasSignupFunnelStarted = (): boolean => hasStartedSignup;

export const markSignupFunnelEngaged = (): void => {
    engagementCount += 1;
};

export const getSignupFunnelEngagementCount = (): number => engagementCount;

export const resetSignupFunnelState = (): void => {
    hasStartedSignup = false;
    engagementCount = 0;
};
